module.exports = __webpack_public_path__ + "img/oil-vein.46d2403c.png";